import React from 'react';
import { HuchaValues } from '../../../models/hucha-values';

import { HuchaCardContainer } from '../../ui/hucha-card-container';
import { HuchaStandardCardC1 } from './hucha-standard-card-c1';
import { HuchaStandardCardC2 } from './hucha-standard-card-c2';
import { HuchaStandardCardC3 } from './hucha-standard-card-c3';

const HuchaStandardCard: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }): React.ReactElement => {
	return (
		<HuchaCardContainer>
			<HuchaStandardCardC1 />
			<HuchaStandardCardC2 />
			<HuchaStandardCardC3 huchaValues={huchaValues} />
		</HuchaCardContainer>
	);
};

export default HuchaStandardCard;
